import { SessionType, type SessionTypeKey } from '@/stores/sessionType'

/**
 * Session type keys that are considered Premium tier (presentation required).
 */
const PREMIUM_KEYS: SessionTypeKey[] = [
  SessionType.EliteUnlimited,
  SessionType.ElitePlus,
  SessionType.Elite,
  SessionType.MostPopular
]

/**
 * Returns true if the given session type key requires a presentation booking.
 */
export function keyRequiresPresentation(key: SessionTypeKey): boolean {
  return PREMIUM_KEYS.includes(key)
}

/**
 * Returns the number of scheduling steps required for a session type.
 * Premium tiers require 2 (session + presentation); others require 1.
 */
export function getSchedulingStepCount(key: SessionTypeKey): number {
  return keyRequiresPresentation(key) ? 2 : 1
}
